<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">G. OTHER AGREEMENTS/UNDERSTANDINGS</p>
                    </div>

                    <!-- Section Items -->
                    <div>
                        <p>
                            <strong>1. ACADEMIC CATALOG & STUDENT HANDBOOK:</strong>
                            The Academic Catalog and
                            Mentora ESL Program Student Handbook contain a description of certain policies,
                            procedures, and other information about BAU and the Mentora College ESL Program.
                            BAU reserves the right to change any provision of the catalog at any time. The current
                            catalog is available online and can be accessed at the following website addresses:
                            <a href="https://bau.edu/mentora-esl/mentora-academic-calendar/" target="_blank">Mentora Handbook</a> and <a href="https://bau.edu/academic-catalog/" target="_blank">BAU Catalog</a>.
                            Students are expected to read and be familiar with
                            the information contained in the most currently published catalog.
                        </p>
                    </div>

                    <div>
                        <p>
                            <strong>2. COMPLIANCE WITH POLICIES, PROCEDURES, AND STANDARDS:</strong>
                            BAU's policies,
                            procedures, and standards are published on the website, located at
                            <a
                                href="https://bau.edu/explore-bau/public-disclosure-policies/all-bau-policies/"
                                target="_blank"
                            >https://bau.edu/explore-bau/public-disclosure-policies/all-bau-policies/</a>.
                            Students are
                            expected to know and must comply with and adhere to all applicable policies,
                            procedures, and standards. Students must also comply with any requirements specified
                            in the student's official admission letter for the Program. You may be suspended,
                            administratively separated, or expelled if you violate any of BAU's policies, rules, or
                            regulations, including attendance requirements, which may result in the revocation of
                            your immigration status. BAU reserves the right to make changes to policies. When
                            doing so, BAU makes announcements to students via email, website updates, and/or
                            posters on the campus. It is the responsibility of the students to check their emails, the
                            website, and the Academic Catalog.
                        </p>
                    </div>
                    <div>
                        <p>
                            <strong>H. PLAGIARISM:</strong>
                            Mentora College holds its students to high standards of academic honesty. Students
                            are expected to submit original work using their own ideas and words. Examples of
                            plagiarism or cheating include, but are not limited to:
                            <br>• Cutting and pasting an internet source
                            <br>• No in-text citations
                            <br>• No bibliography provided
                            <br>• Copying another student's work
                            <br>• Communicating answers during exams/ quizzes
                            <br>• Re-using your own or another student's work from a previous class
                            <br>• Using AI programs like ChatGPT, perplexity, etc.
                            <br><br>
                            <strong>1st Offense:</strong> If cheating, the student will receive up to 2 verbal warnings by the
                            teacher before they are removed from the class. Students will receive 0% on
                            their exam/quiz.
                            <br>
                            If plagiarism, the student may be given another chance to do the assignment
                            under the supervision of the teacher. The resubmission may be scored at a
                            maximum grade of 50%
                            <br><br>
                            <strong>2nd Offense:</strong> The student will receive a zero (0) and a warning letter for
                            Behavior Performance. The student will be placed on Behavior probation.
                            <br><br>
                            <strong>3rd Offense:</strong> The student will receive a zero (0) and face expulsion and/or
                            termination of the student's I-20 Form.
                            <br><br>
                            Teachers and the Academic team will properly document all offenses 1-3.
                            Teachers will be responsible for writing an incident report and the Academic
                            team will follow up with the warning or probation letters prepared.
                            Plagiarism and Cheating are NOT tolerated at Mentora College, and any cases
                            will be handled swiftly and seriously.
                            <br><br>
                            I read and confirm that I understand the information in Section H.
                        </p>
                    </div>

                    <div>
                        <p>
                            <strong>I. ACADEMIC CALENDAR:</strong>
                            Students should familiarize themselves with the Mentora
                            College ESL Program calendar for holidays and vacations published on the website at
                            <a href="https://bau.edu/mentora-esl/mentora-academic-calendar/" target="_blank">https://bau.edu/mentora-esl/mentora-academic-calendar</a>.
                            Classes will not be held on designated school
                            vacations and may be canceled on public holidays. BAU does not provide refunds for
                            classes not offered due to planned or unplanned school closures.
                        </p>
                    </div>

                    <div>
                        <p>
                            <strong>J. IMPLIED CONSENT:</strong>
                            You acknowledge and agree that BAU or its representatives,
                            affiliates, successors, and related companies may photograph, video or otherwise record
                            you and/or other students. If you do not wish to have your photograph or video taken, you
                            must advise BAU in writing and state, at the time of the photography or recording, your
                            desire not to participate. Unless you have provided us with notice regarding your desire
                            not to participate, you hereby irrevocably grant BAU and its assigns, licensees,
                            successors in interest, legal representatives, employees, consultants and agents
                            (collectively, the “Program Entities”) the irrevocable and unrestricted right to copy, publicly
                            display, distribute, modify, create derivative works of and otherwise use your name,
                            image, voice and likeness and any photograph, video or audio recording in which you
                            appear (collectively, the “Images”). You acknowledge and agree that you have no right,
                            title or interest in or to any Images, and that the Program Entities own all right, title and
                            interest in and to all Images. You hereby waive any right to inspect or approve any
                            Images. You hereby waive all rights and release and discharge the Program Entities from
                            and shall neither sue nor bring any proceeding against the Program Entities for, any claim,
                            demand or cause of action based upon, arising from or related to the Program Entities use
                            or exploitation of the Images (or the use of your name, image, voice or likeness in
                            connection therewith), including without limitation, claims for libel or invasion of right to
                            privacy, publicity or personality. You can always visit  <a href="https://bau.edu/explore-bau/public-disclosure-policies/communication-policies-and-procedures/">BAU Communication Policies</a> to learn more about the specific settings where implied consent is applied.
                        </p>
                    </div>

                    <div>
                        <p>
                            <strong>K. COMPLAINTS:</strong>
                            A student or any member of the public may file a complaint about this
                            institution on issues that cannot be resolved by direct negotiation with the school in
                            accordance with its written grievance policy with the Higher Education Licensure
                            Commission (HELC) at 1050 First Street NE Washington, DC 20002, (202) 727-6436.
                        </p>
                    </div>

                    <div>
                        <p>
                            <strong>L. LEGAL:</strong>
                            The law, including the statutes of limitation, of the District of Columbia will govern
                            this Agreement, the interpretation and enforcement of its terms and any claim or cause of
                            action (in law or equity), controversy or dispute arising out of or related to it or its
                            negotiation, execution or performance, whether based on contract, tort, statutory or other
                            law, in each case without giving effect to any conflicts-of-law or other principle requiring
                            the application of the law of any other jurisdiction. Each of the parties hereto hereby
                            irrevocably and unconditionally consents to submit to the sole and exclusive jurisdiction of
                            the courts of the District of Columbia and of the United States of America located in
                            Washington, D.C. (the “Washington, D.C. Courts”) for any litigation among the parties
                            hereto arising out of or relating to this Agreement, or the negotiation, validity or
                            performance of this Agreement, waives any objection to the laying of venue of any such
                            litigation in the Washington, D.C. Courts and agrees not to plead or claim in any
                            Washington, D.C. Court that such litigation brought therein has been brought in any
                            inconvenient forum or that there are indispensable parties to such litigation that are not
                            subject to the jurisdiction of the Washington, D.C. Courts.
                        </p>
                    </div>

                    <div>
                        <p>
                            <strong>M. COPY OF THE ENROLLMENT AGREEMENT:</strong>
                            A copy of this Contract will be emailed to
                            the student upon signing and will be accessible on the student’s MyBAU account.
                        </p>
                    </div>
                </b-col>

                <!-- Checkbox + Button -->
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider name="status" rules="required" v-slot="{ errors }">
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="ml-4"
                                    >
                                    </b-form-checkbox>
                                    I read and confirm that I understand the information in Section G.
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                status: null,
            },
        }
    },
    created() {
        window.scrollTo(0, 0)
    },
    methods: {
        async next() {
            const isValid = await this.$refs.formModalValidate.validate()
            if (isValid) {
                this.$emit('next', 1)
            }
        },
        back() {
            this.$emit('back', -1)
        },
    },
}
</script>

<style>
body {
    font-family: Arial, sans-serif;
    margin: 40px;
    line-height: 1.6;
}
h2 {
    text-align: center;
    margin-bottom: 20px;
}
.section {
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 6px;
    margin-bottom: 20px;
    background: #f9f9f9;
}
</style>
